export const channelTypeItems = [
    { key: 'Analog', value: 'Analog' },
    { key: 'Digital', value: 'Digital' },
];

export type DeviceProfileData = {
    key: string;
    value: {
        profileId: string;
        profileName: string;
    };
};
